import { memo } from 'react';

import { Spinner } from '@air/primitive-spinner';

export const AssetVersionThumbnailProcessingPreview = memo(() => {
  return (
    <div
      className="flex size-full items-center justify-center ads:bg-subtle bg-gray-6"
      data-testid="ASSET_VERSION_THUMBNAIL_PROCESSING_PREVIEW"
    >
      <Spinner className="size-4 ads:text-icon-primary text-blue-9" />
    </div>
  );
});

AssetVersionThumbnailProcessingPreview.displayName = 'AssetVersionThumbnailProcessingPreview';
